import { useTranslation } from 'react-i18next';
import { SchemaType, Yup } from '@root/utils/ValidationSchemas/Index';
import _ from 'lodash';

export const Schema = (
    disableEditableAmount: boolean = false,
    prefixFields: string = '',
): SchemaType => {
    const { t } = useTranslation('uiPaymentsTopup');
    let paymentValidation = {};
    paymentValidation[`${prefixFields}amount`] = Yup.number()
        .positive()
        .transform((_, value) => {
            if (typeof value !== 'string') {
                return value;
            }
            if (!value.includes(',')) {
                return parseFloat(value);
            }
            return parseFloat(value.replace(/,/, '.'));
        })
        .transform((value) => (!isNaN(value) ? value : undefined))
        .required(
            t('macro.form.errors.validation.required', {
                defaultValue: 'Laukelis privalomas.',
            }),
        );
    if (!disableEditableAmount) {
        paymentValidation[`${prefixFields}amount`] = paymentValidation[
            `${prefixFields}amount`
        ].min(
            4,
            t('macro.form.errors.validation.min', {
                defaultValue: 'Minimalus sumokėjimo suma yra 4 Eur.',
            }),
        );
    }
    return paymentValidation;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const init = (disableEditableAmount?: boolean) =>
    Yup.object().shape(Schema(disableEditableAmount));

export { init };

export default Schema;
